<template>
  <select
    v-model="this.$i18n.locale"
    class="form-select w-25  m-3"
    aria-label="Default select example"
    @change="onChange"
  >
    <option v-for="(lang, i) in langs" :key="`lang-${i}`">
      {{ lang == "en" ? lang : lang }}
    </option>
  </select>
  <div class="w-100 px-5 py-2">
    <div class="row  border mx-auto  rounded h-100">
      <div class="  bg-white col-md-6  col-sm-6 p-0">
        <div class="w-100 h-50">
          <img
            src="./assets/img/ching-image.png"
            class="  w-100 img-fluid  h-100"
          />
        </div>
        <div class="w-100 p-3  ">
          <img
            src="./assets/img/logo.png"
            alt=""
            class="  d-block mx-auto  img-fluid "
          />
        </div>
      </div>
      <div class=" col-lg-6 col-12 col-md-6 col-sm-6 border">
        <h1 class="m-3 bg-primary text-white p-3 rounded h3 text-center ">
          Chinguitel | Gimtel
        </h1>
        <form class="m-3" @submit="onSubmit">
          <div>
            <label for="phone" class="form-label text-secondary">
              {{ this.$t("main.phone") }}
            </label>
            <input
              type="phone"
              v-model="phone"
              name="phone"
              placeholder="2 * * * * * * * *"
              class="form-control "
              required
            />
          </div>

          <div class="mt-3">
            <label for="amount" class="form-label text-secondary">
              {{ this.$t("main.amount") }}
            </label>
            <input
              type="amount"
              name="amount"
              v-model="amount"
              :placeholder="this.$t('main.amount')"
              class="form-control "
              required
            />
          </div>
          <div v-if="loading" class="w-100 text-center mt-2">
            <div class="spinner-border text-primary mx-auto" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <button v-if="!loading" class="btn btn-primary form-control mt-3">
            {{ this.$t("main.submit") }}
          </button>
        </form>
        <div class="w-75 mx-auto my-4">
          <a
            href=" https://www.facebook.com/chinguitel.mr/?_rdc=2&_rdr"
            target="_blank"
          >
            <img src="./assets/img/facebook.png" alt="" width="40" class="mx-2"
          /></a>
          <a
            class=""
            href="https://www.instagram.com/chinguitel_sa/?hl=fr"
            target="_blank"
          >
            <img src="./assets/img/insta.png" width="40" alt="" />
          </a>
          <a
            class=""
            href="https://www.linkedin.com/company/chinguitel"
            target="_blank"
          >
            <img src="./assets/img/lk.png" width="40" alt="" class="mx-2" />
          </a>
          <a href="https://twitter.com/Chinguitel" target="_blank">
            <img src="./assets/img/tweeter.png" alt="" width="40" class="mx-2"
          /></a>
          <a href="">
            <img src="./assets/img/122.png" alt="" width="50" class="mx-2" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCBW90Ob2cpo74E_CG5nC2Jg/featured"
            target="_blank"
          >
            <img src="./assets/img/youtube.png" alt="" width="40" class="mx-2"
          /></a>
          <a
            href="https://www.chinguitel.mr/?fbclid=IwAR2MTmqyWDzcVNyAS123QVS1W3mR8EubojtCzVO6q0hAYpKdRv_n_ekDro4"
          >
            <img src="./assets/img/www.png" alt="" width="40" class="mx-2" />
          </a>
        </div>

        <Alert v-if="error" :msg="error" :limit="limit" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from "vue";
import Alert from "./components/Alert.vue";
export default {
  name: "App",
  components: { Alert },
  methods: {
    onChange() {
      localStorage.setItem("lang", this.$i18n.locale);
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    const myApp = document.querySelector("#app");
    if (this.lang == "ar") {
      console.log("arabic is");
      if (!myApp.classList.contains("rtl")) {
        myApp.classList.remove("ltr");
        myApp.classList.add("rtl");
      }
    } else {
      if (!myApp.classList.contains("ltr")) {
        myApp.classList.add("ltr");
      }
    }
  },

  watch: {
    lang(newVal) {
      const myApp = document.querySelector("#app");
      if (newVal == "ar") {
        if (!myApp.classList.contains("rtl")) {
          myApp.classList.remove("ltr");
          myApp.classList.add("rtl");
        }
      } else {
        if (!myApp.classList.contains("ltr")) {
          myApp.classList.remove("rtl");
          myApp.classList.add("ltr");
        }
      }
    },
  },

  setup() {
    const state = reactive({
      phone: null,
      amount: null,
      checkNumber,
      error: null,
      langs: ["fr", "ar"],
      limit: null,
      loading: false,
    });
    var currentdate = new Date();
    var currentDateTime =
      currentdate.getFullYear() +
      "-" +
      (currentdate.getMonth() + 1) +
      "-" +
      currentdate.getDate() +
      " " +
      currentdate.getHours() +
      ":" +
      currentdate.getMinutes() +
      ":" +
      currentdate.getSeconds();

    async function onSubmit(e) {
      e.preventDefault();
      state.error = null;

      await checkNumber();
    }
    async function checkNumber() {
      state.loading = true;
      const ipData = await fetch("https://api.ipify.org?format=json");
      const deviceIp = await ipData.json();
      try {
        const checkMdnResult = await fetch(
          "https://www.chinguitel.mr/gimtel/checkNumber",
          {
            method: "post",
            mode: "cors",
            body: JSON.stringify({ mdn: state.phone }),
            headers: { "Content-Type": "application/json" },
          }
        );
        const checkMdn = await checkMdnResult.json();
        if (checkMdn.result) {
          const paymentResponse = await fetch(
            "https://www.chinguitel.mr/gimtel/payment",
            {
              method: "post",
              mode: "cors",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                cardHolderPhoneNumber: state.phone,
                transactionAmount: state.amount,
                cardHolderIPAddress: deviceIp.ip,
                dateTimeBuyer: currentDateTime,
                countryCode: " ",
                os: " ",
              }),
            }
          );
          const paymentData = await paymentResponse.json();
          if (!paymentData.success) {
            state.error = paymentData.msg;
            state.limit = paymentData.value;
            state.loading = false;
          } else {
            state.loading = false;
            console.log(paymentData);
            window.location = paymentData.redirectUrl;
          }
        } else {
          state.loading = false;
          state.error = "Invalid Phone Number";
        }
        console.log(checkMdn.result);
      } catch (err) {
        state.loading = false;
        state.error = err.message;
      }
    }

    return { ...toRefs(state), onSubmit };
  },
};
</script>
